import React from 'react'
import { Helmet } from 'react-helmet'
import { ThemeProvider } from 'styled-components'

import '@theme/sanitize.css'
import '@theme/fonts.css'
import { mainTheme } from '@theme/theme'

import Header from '@organisms/Header'
import CookieBanner from '@organisms/CookieBanner'

import { GlobalStyle } from './styles.js'

const SITE_URL = 'https://hellomola.com'

const Outter = ({ location, children }) => {
  // Every page is its own canonical (pathname keeps Gatsby's trailing slash)
  const pathname = location?.pathname || '/'
  const isNotFound = pathname.startsWith('/404')

  return (
    <ThemeProvider theme={mainTheme}>
      {!isNotFound && (
        <Helmet>
          <link rel="canonical" href={`${SITE_URL}${pathname}`} />
        </Helmet>
      )}
      <GlobalStyle />
      <Header />
      {children}
      <CookieBanner />
    </ThemeProvider>
  )
}

export default Outter
